// extracted by css-extract-rspack-plugin
export default {"sortable":"BgFId","sortingIcon":"LVqMZ","active":"JgklD","sortingControl":"_1yNbv"};